import { createReducer } from '@reduxjs/toolkit'

import { InternalGa4Actions } from './actions'
import type { Ga4State } from './types'

const initialState: Ga4State = {
  status: 'idle',
  updatedAt: null,
  propertyId: null,
  propertyName: null,
  hostname: '',
  pages: {},
  properties: null,
  propertiesLoading: false,
  connecting: false,
  savingProperty: false,
  resyncing: false,
}

export const ga4 = createReducer<Ga4State>(initialState, (builder) => {
  builder
    // Начало запроса статус не трогает: обновление отчёта (вход в SEO-режим,
    // resync, правка адреса страницы) не должно стирать уже известное
    // подключение — на экране от этого мигают и кнопка, и ушки с метриками.
    .addCase(InternalGa4Actions.reportLoaded, (state, { payload }) => ({
      ...state,
      status: payload.status,
      updatedAt: payload.updatedAt ?? null,
      propertyId: payload.propertyId ?? null,
      propertyName: payload.propertyName ?? null,
      hostname: payload.hostname ?? '',
      pages: payload.pages ?? {},
    }))
    .addCase(InternalGa4Actions.reportFailed, (state, { payload }) => ({
      ...state,
      status: payload,
      pages: {},
    }))
    .addCase(InternalGa4Actions.propertiesLoading, (state) => ({
      ...state,
      propertiesLoading: true,
    }))
    .addCase(InternalGa4Actions.propertiesLoaded, (state, { payload }) => ({
      ...state,
      properties: payload,
      propertiesLoading: false,
    }))
    .addCase(InternalGa4Actions.connecting, (state, { payload }) => ({
      ...state,
      connecting: payload,
    }))
    .addCase(InternalGa4Actions.savingProperty, (state, { payload }) => ({
      ...state,
      savingProperty: payload,
    }))
    .addCase(InternalGa4Actions.resyncing, (state, { payload }) => ({
      ...state,
      resyncing: payload,
    }))
    .addCase(InternalGa4Actions.reset, () => initialState)
})
